module.exports = __webpack_public_path__ + "img/debtPayingAbility1.a87342f0.png";